import { buttonRoundnessMultiplier } from "../../constants";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { Skeleton } from "../Skeleton";

const HEADER_ICON_SIZE = 44;
const DONUT_SIZE = 56;
const TITLE_LINE_HEIGHT = 24;
const BODY_LINE_HEIGHT = 20;
const LABEL_LINE_HEIGHT = 16;
const CHIP_HEIGHT = 28;
const OUTLINED_CTA_HEIGHT = 40;
const TEXT_BUTTON_HEIGHT = 38;

type Props = {
	titleWidth?: `${number}%`;
	numRows?: number;
	showActions?: boolean;
};

const TextLine = ({
	lineHeight,
	barHeight,
	width,
}: {
	lineHeight: number;
	barHeight: number;
	width: number | `${number}%`;
}) => (
	<Box height={lineHeight} justifyContent="center">
		<Skeleton width={width} height={barHeight} />
	</Box>
);

export const ProgressCardSkeleton = ({
	titleWidth = "70%",
	numRows = 4,
	showActions = true,
}: Props) => {
	const theme = useAppTheme();

	return (
		<FlatCard style={{ overflow: "hidden" }}>
			<Box paddingHorizontal={16} paddingTop={16}>
				<Box flexDirection="row" alignItems="center" gap={12}>
					<Skeleton size={HEADER_ICON_SIZE} variant="circle" />
					<Box flex={1} gap={2}>
						<TextLine
							lineHeight={TITLE_LINE_HEIGHT}
							barHeight={16}
							width={titleWidth}
						/>
						<TextLine
							lineHeight={LABEL_LINE_HEIGHT}
							barHeight={12}
							width="40%"
						/>
					</Box>
				</Box>
			</Box>
			<Box>
				{Array.from({ length: numRows }).map((_, rowIndex) => (
					<Box
						// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton rows
						key={rowIndex}
						flexDirection="row"
						alignItems="center"
						gap={16}
						paddingHorizontal={8}
						paddingVertical={14}
					>
						<Skeleton
							size={DONUT_SIZE}
							variant="circle"
							style={{
								marginLeft: 8,
							}}
						/>
						<Box flex={1} minWidth={0} gap={4}>
							<TextLine
								lineHeight={BODY_LINE_HEIGHT}
								barHeight={16}
								width={"100%"}
							/>
							<Skeleton width={96} height={CHIP_HEIGHT} />
						</Box>
						<Skeleton
							width={120}
							height={OUTLINED_CTA_HEIGHT}
							borderRadius={theme.roundness * buttonRoundnessMultiplier}
						/>
					</Box>
				))}
			</Box>
			{showActions ? (
				<Box
					flexDirection="row"
					alignItems="center"
					justifyContent="flex-end"
					paddingHorizontal={8}
					paddingVertical={8}
				>
					<Skeleton
						width={120}
						height={TEXT_BUTTON_HEIGHT}
						borderRadius={theme.roundness * buttonRoundnessMultiplier}
					/>
				</Box>
			) : null}
		</FlatCard>
	);
};
